/**
 * Should the full-script handoff swap the queue and jump to the learner's saved
 * position (the stale-matview resume repair)? Job #812.
 *
 * The repair exists for ONE case: the bootstrap landed somewhere other than the
 * learner's saved position (a stale matview put them at R1). It must NOT fire
 * when the bootstrap landed correctly and the learner has since pressed back —
 * the saved position is then "ahead" of where they now are, and the repair
 * would yank them forward to it, undoing their back press the moment the walk
 * finishes. "Bootstrap landed on the saved position" is therefore the veto.
 */
export function shouldRepairResume(args: {
  /** The LEGO the bootstrap landed the player on. */
  startedAtLegoId: string | null | undefined
  /** The learner's saved position, resolved in the full script. */
  trueLegoId: string | null | undefined
  trueIdx: number
  /** Index in the full script of where the player is now (-1 = not found). */
  landedIdx: number
}): boolean {
  const { startedAtLegoId, trueLegoId, trueIdx, landedIdx } = args
  if (trueIdx < 0) return false
  if (startedAtLegoId && trueLegoId && startedAtLegoId === trueLegoId) return false
  return landedIdx < 0 || trueIdx > landedIdx
}
